<template>
  <div id="quantitiesMain">
    <WorkPackageSubPageModule
      id="workPackageSubPageModuleQuantities"
      :workpackage="{textcolor: '#fff'}"
      :isMobile="true"
      :location="location"
      :loading="loading"
      background_color="#424242"
      foreground_color="#fff"
      header_icon="sign-sum"
      header_text_short="Quantities"
      header_text_long="TAKT.area Quantities"
      @headerBack="$router.push({name: `${location}TaktareaDetailsInfo`})"
      :viewerMinimized="viewerMinimized"
      :style="{ height: viewerMinimized ? '80%' : '33%' }"
      >
      <template #header-rightside>
      </template>
      <template #header-below>
      </template>
      <template #sort-buttons>
      </template>
      <template #body v-if="!loading">
        <!-- <h2>Quantities</h2> -->
        <!-- TABLE -->
        <div style="width:100%;display:flex;flex-direction: column">
          <!-- TABLE HEADERS -->
          <div style="width:100%;display:flex; flex-direction: row;justify-content: space-around;" class="mb-1">
            <FillableCell>
              <template #content>
                <TText color="#fff" value="IFC.type" font_weight="500" />
              </template>
            </FillableCell>
            <FillableCell>
              <template #content>
                <TText color="#fff" value="Count" font_weight="500" />
              </template>
            </FillableCell>
            <FillableCell>
              <template #content>
                <TText color="#fff" value="Lateral Surface" font_weight="500" />
              </template>
            </FillableCell>
            <FillableCell>
              <template #content>
                <TText color="#fff" value="Perimeter" font_weight="500" />
              </template>
            </FillableCell>
            <FillableCell>
              <template #content>
                <TText color="#fff" value="Floor Area" font_weight="500" />
              </template>
            </FillableCell>
            <FillableCell>
              <template #content>
                <TText color="#fff" value="Volume" font_weight="500" />
              </template>
            </FillableCell>
            <FillableCell>
              <template #content>
                <TText color="#fff" value="Height" font_weight="500" />
              </template>
            </FillableCell>
            <FillableCell>
              <template #content>
                <TText color="#fff" value="Length" font_weight="500" />
              </template>
            </FillableCell>
            <FillableCell>
              <template #content>
                <TText color="#fff" value="Width" font_weight="500" />
              </template>
            </FillableCell>
            <FillableCell>
              <template #content>
                <TText color="#fff" value="Weight" font_weight="500" />
              </template>
            </FillableCell>
            <FillableCell>
              <template #content>
                <TText color="#fff" value="Side Area" font_weight="500" />
              </template>
            </FillableCell>
            <FillableCell>
              <template #content>
                <TText color="#fff" value="Surface" font_weight="500" />
              </template>
            </FillableCell>
          </div>
          <!-- TABLE CONTENT -->
          <div style="width:100%;display:flex; flex-direction: column;overflow-y: scroll;">
            <div style="width:100%;display:flex; flex-direction: row;justify-content: space-around;" v-for="ifc_type in Object.keys(quantities)" :key="`ifc_type${ifc_type}`">
              <FillableCell>
                <template #content>
                  <TText color="#fff" :text="ifc_type"  />
                </template>
              </FillableCell>
              <FillableCell>
                <template #content>
                  <TText color="#fff" :text="quantities[ifc_type].count"  />
                </template>
              </FillableCell>
              <FillableCell>
                <template #content>
                  <TText color="#fff" :text="quantities[ifc_type].lateral_surface.toFixed(2)"  />
                </template>
              </FillableCell>
              <FillableCell>
                <template #content>
                  <TText color="#fff" :text="quantities[ifc_type].perimeter.toFixed(2)"  />
                </template>
              </FillableCell>
              <FillableCell>
                <template #content>
                  <TText color="#fff" :text="quantities[ifc_type].floor_area.toFixed(2)"  />
                </template>
              </FillableCell>
              <FillableCell>
                <template #content>
                  <TText color="#fff" :text="quantities[ifc_type].volume.toFixed(2)"  />
                </template>
              </FillableCell>
              <FillableCell>
                <template #content>
                  <TText color="#fff" :text="quantities[ifc_type].height.toFixed(2)"  />
                </template>
              </FillableCell>
              <FillableCell>
                <template #content>
                  <TText color="#fff" :text="quantities[ifc_type].length.toFixed(2)"  />
                </template>
              </FillableCell>
              <FillableCell>
                <template #content>
                  <TText color="#fff" :text="quantities[ifc_type].width.toFixed(2)"  />
                </template>
              </FillableCell>
              <FillableCell>
                <template #content>
                  <TText color="#fff" :text="quantities[ifc_type].weight.toFixed(2)"  />
                </template>
              </FillableCell>
              <FillableCell>
                <template #content>
                  <TText color="#fff" :text="quantities[ifc_type].side_area.toFixed(2)"  />
                </template>
              </FillableCell>
              <FillableCell>
                <template #content>
                  <TText color="#fff" :text="quantities[ifc_type].surface.toFixed(2)"  />
                </template>
              </FillableCell>
            </div>
          </div>
        </div>


      </template>
    </WorkPackageSubPageModule>
    <BimVisualization
    :viewerMinimized="viewerMinimized"
    @toggleViewerMinimize="toggleViewerMinimize" 
    :style="{ height: viewerMinimized ? '20%' : '67%' }">
    </BimVisualization>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import WorkPackageSubPageModule from '@/modules/WorkPackageWIP/WorkPackageSubPageModule.module.vue';
//  import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue';
import FillableCell from '@/components/WorkPackageWIP/FillableCell.component.vue';

import { TrainTaktareaDetailsMixin } from '@/mixins/TrainTaktareaDetails.mixin.js'
import BimVisualization from '@/components/ProjectTaktPlan/BimVisualization.component.vue';

  export default {
    components: {
      WorkPackageSubPageModule,
      FillableCell,
      // DisableableInputField,
      BimVisualization
    },
    mixins: [TrainTaktareaDetailsMixin],
    props: [],
    data: () => ({
      loading: true,
      viewerMinimized: false,
    }),
    created() {
      this.requestUObject({
        url: [
          { projects: this.$route.params.project_id },
          { trains: this.$route.params.train_id },
          { taktareas: this.$route.params.taktarea_id },
          { elements: '' },
          { showWithEntitiesNormalized: '' }
        ],
        add_u_object: true
      }).then(() => {
        this.loading = false;
      })
    },
    computed: {
      taktarea(){
        return this.getUObject({ type: 'taktareas', id: this.$route.params.taktarea_id });
      },
      quantities(){
        return this.getQuantitiesByElementIds(this.taktarea.elements);
      },
      ...mapGetters('ProjectStructure', [
        'getQuantitiesByElementIds',
      ]),
      ...mapGetters('Ultra', [
        'getUObject',
      ]),
    },
    methods: {
      toggleViewerMinimize() {
        this.viewerMinimized = !this.viewerMinimized;
      },
     ...mapActions('Ultra', [
      'requestUObject'
     ]),
    },
    watch: {
      viewerMinimized: function() {
        this.$nextTick(() => {
          window.dispatchEvent(new Event('resize'));
        });
      },
    },
  }
</script>


<style scoped>
  #workPackageSubPageModuleQuantities {
    /* height: 33%; */
    position: relative !important;
  }

  #quantitiesMain {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
  }

  .subpage-header-component-content {
    /* wird ohne important nicht wirksam */
    position: absolute !important;
    background-color: transparent;
  }


</style>